import { css } from '@emotion/react';

import type { TextButton } from '@/components/TextButton';

export const root = ({ color, weight, underline, fontSize }: TextButton) => css`
  font-size: ${fontSize ? fontSize : '1.6rem'};
  font-weight: ${weight};
  color: ${color};
  text-decoration: ${underline ? 'underline' : 'none'};
  &:hover {
    text-decoration: ${underline ? 'none' : 'underline'};
  }
`;
